import type { MetaDataContext } from './types';
import type { UserProfile } from '../../types';

type Props = {
  data: {
    user: UserProfile;
  };
  offset?: number;
  section?: 'reviews';
};

const profileMetaTags = (
  { data, offset, section }: Props,
  { market, t }: MetaDataContext
) => {
  if (!data || !data.user) {
    return {};
  }

  const baseUrl = `${market.domain}/user/${data.user.id}`;

  // Canonicalise to the section URL
  const url = section
    ? `${baseUrl}/${section}`
    : // Default section renders reviews
      `${baseUrl}/reviews`;

  // Self canonicalise each offset page to make Google index it as its
  // own unique page
  const canonical = offset ? `${url}?offset=${offset}` : url;

  const metaTags = {
    title: t('meta', 'profile.page-title', {
      user: data.user.displayName || t('account', 'profile.title'),
    }),
    description: null,
    canonical,
    openGraph: [],
    structuredData: undefined,
    hrefLang: [],
  };

  return metaTags;
};

export default profileMetaTags;
